export default "__VITE_ASSET__kOBb7dGW__"